import React from "react";
import { useState } from "react";
import { Button } from "../Components";
import {IoCloseOutline} from 'react-icons/io5'
import './../Components/Lightbox/Lightbox.css'
/**
 * 
 * @param {*} param0 
 * @returns 
 */
const LightboxModal = ({ image , open , onCancel }) => {

    const [isLoad, setIsLoad] = useState(false)
	return (
		<div className={`lightbox ${open ? 'show' : ''}  `}   onClick={onCancel}>
			<div className="lightbox-wrapper">
                {
                    isLoad === true 
                    ? 'Loading...'
                    : <>
                    
                        <img 
                            src={image} 
                            alt=""
                            onLoad={() => setIsLoad({loaded: true})}/>
                         
                    </>
                }
                <Button className="close-btn" onClick={onCancel}><IoCloseOutline /></Button>
			</div>
		</div>
	);
};

const LightboxModalContext = React.createContext({});

/**
 * 
 * @param {*} param0 
 * @returns 
 */
const LightboxProvider = ({ children }) => {
	const [lightOpen, setLightOpen] = React.useState(false);
	const [modalConfig, setModalConfig] = React.useState({});

	const openModal = ({ image ,  onCancel}) => {
		setLightOpen(true);
		setModalConfig({ image , onCancel});
	};

	const resetModal = () => {
		setLightOpen(false);
		setModalConfig({});
	};

	const onConfirm = () => {
		resetModal();
		modalConfig.actionCallback(true);
		modalConfig.onConfirm();
		
	};
	
	const onCancel = () => {
		resetModal();
		modalConfig.actionCallback(false);
		modalConfig.onCancel();
	};

	return (
		<LightboxModalContext.Provider value={{ openModal }}>
			{children}
			{
				lightOpen && 
				<LightboxModal
                    image={modalConfig?.image}
					open={lightOpen}
					onCancel={onCancel}
				/>
			}
		</LightboxModalContext.Provider>
	);
};

/**
 * 
 * @returns 
 */
const useLightboxModal = () => {
  const { openModal } = React.useContext(LightboxModalContext);

  const displayLightbox = ({ ...options }) =>
	new Promise((res) => {
	  openModal({ actionCallback: res, ...options });
	});

  return { displayLightbox };
};

export default LightboxModal;
export { LightboxProvider, useLightboxModal };
